enum ETeamPlayerRole {
    "Player",
    "Reserve",
    "Coach"
}

export default ETeamPlayerRole